import React, { Component } from 'react'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import { Col, Row } from 'react-bootstrap'
import moment from 'moment'
import cssVar from '../../styles/variables'
import CalendarRow from './CalendarRow'

import { CalendarBox, DateHeading, GolfCourseHeading } from './BookingCalendarStyle'

import ReactGA from "react-ga";

@inject('golfCourseStore', 'datesStore')

@observer
class BookingCalendar extends Component {

  // Check https://github.com/mobxjs/mobx-react/blob/master/README.md#faq
  // to see why I did this (componentWillMount())
  // To replicate the error that occurs otherwise put
  // this.props.datesStore.getCurrentWeek()
  // into the constructor and see what happens.

  componentWillMount() {
    this.props.datesStore.getCurrentWeek()
  }

  trackNextWeek() {
    ReactGA.event({
      category: 'Booking',
      action: 'Navigate',
      label: 'Next Week - Booking Calendar'
    });
  }

  trackPrevWeek() {
    ReactGA.event({
      category: 'Booking',
      action: 'Navigate',
      label: 'Previous Week - Booking Calendar'
    });
  }

  render() {
    const { golfCoursesBookings } = this.props.golfCourseStore

    const datesHeadings = (
      this.props.datesStore.dates.map(
        (date, key) =>
          <Col sm={1} xsHidden md={1} lg={1} key={key}>
            <GolfCourseHeading>{moment(JSON.stringify(date).substr(1, 10)).locale("de").format('dd DD.MM')}</GolfCourseHeading>
          </Col>
      )
    )

    const calendarRows = (
      golfCoursesBookings.map((bookingsObject, key) => {
        return <CalendarRow
          bookingsPerDate={bookingsObject.bookingsPerDate}
          golfCourse={bookingsObject.golfCourse}
          key={key}
        />
      }
      )
    )

    const weekNavigator = (
      <Col xs={12} sm={2} md={2} lg={2} style={{paddingLeft: 30}}>
        <Col xs={2} sm={4} md={6} lg={2} onClick={() => {
          this.props.datesStore.getPreviousWeek();
          this.props.golfCourseStore.checkBookingLimitation();
          this.trackPrevWeek()
        }} style={{ padding: 0, cursor: "pointer" }}>
          <h4 >
            &lt;
            </h4>
        </Col >
        <Col xs={8} smHidden mdHidden lg={8} style={{ padding: 0 }}>
          <h4>
            WOCHE {this.props.datesStore.currentWeekNumber - 1}
          </h4>
        </Col >
        <Col xs={2} sm={4} md={6} lg={2} onClick={() => {
          this.props.datesStore.getNextWeek();
          this.trackPrevWeek()
        }} style={{ padding: 0, cursor: "pointer" }}>
          <h4>
            &gt;
            </h4>
        </Col >
      </Col >
    )

    return (
      <CalendarBox>
        <Row className={"nine-cols"}>
          <DateHeading className={"nine-cols no-padding-row"} style={{padding: '20px 0px'}} color={cssVar.colors.blue}>
            {weekNavigator}
            {datesHeadings}
          </DateHeading>
          {calendarRows}
        </Row>
      </CalendarBox>
    )
  }
}

BookingCalendar.propTypes = {
  golfCourseStore: MobxPropTypes.observableObject,
  datesStore: MobxPropTypes.observableObject,
}

export default BookingCalendar



// WEBPACK FOOTER //
// /src/components/internal/BookingCalendar.js